import { SxProps } from '@mui/material/styles';

export const facetNavigationFacetEntryFormControlLabelSX = {
	width: ['auto', 'auto', '100%'],
};

export const currentStoreLocatorLabelSX: SxProps = {
	pt: 1.125,
	'& .MuiButtonBase-root': {
		py: 0,
	},
};

export const facetNavigationFacetEntrySwatchSX: SxProps = {
	mb: 1,
	mr: 1,
};
